import React from "react";
import { Alerts } from "@common";
import { useSessionContext } from '@contexts';
import PropTypes from 'prop-types';
import { Constants, helpers } from "@shared";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";

const NoBill = ({ alerts }) => {
    const { session } = useSessionContext();

    const {
        accountPreferences: { isAutoPay },
    } = session;

    return (
        <div className="page-content-wrapper w-full gap-y-5">
            <h1 className="page-header">My Dashboard</h1>
            <Alerts alerts={alerts} />

            <div className="content-box shadow-sb ">
                {
                    isAutoPay &&
                    <div className="text-gray-500 text-2xl inline-flex">
                        <span className="inline-flex">Auto-pay is on<a href={Constants.Help.AutoPay} target="_blank" rel="noreferrer"><ExclamationCircleIcon className="h-6 ml-1" /></a></span>
                    </div>
                }
                <button type="button" className="btn btn-primary rounded-full text-2xl w-full" disabled>No Bills to Pay</button>
                <div className="w-full border-t-2 border-header"></div>
                <span className="text-lg text-center text-gray-500">You’ll be notified by email when a bill arrives, and your dashboard will be updated.</span>
                <span className="text-lg text-center text-gray-500">In the meantime, click <b>My Account</b> above to see statements or manage settings.</span>
            </div>
        </div >
    );
};

NoBill.propTypes = {
    alerts: PropTypes.array
};

export default NoBill;